module.exports = __webpack_public_path__ + "static/media/DSCF0183-IguoiYgs.dc00527a.JPG";